import { render } from "./StarRating.vue?vue&type=template&id=7a15e9f1"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=7a15e9f1&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__